// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","logo":"src-components-Footer----footer-module---logo---37gz6","nav":"src-components-Footer----footer-module---nav---3fLV-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.scss
// module id = 343
// module chunks = 35783957827783